(function ClientOpportunityFollowups($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		$("#ClientOpportunityFollowUpIndexForm #followup_type").change(function filter(event) {
			var $self       = $(this),
			    archived    = $("#ClientOpportunityFollowUpIndexForm #archived").val(),
			    url         = Adzuki.get_url("/ClientOpportunityFollowups/index/" + archived + "/" + $self.val());

			window.location = url;
		});
	});

}(jQuery, window.Adzuki || {}));
